{
  "name": "53 < 256° isomorphic",
  "description": "53-tone Rational Intonation gamut, based on the set of pitch classes derived from odd harmonic partials not exceeding 256°. To divide each whole tone into 9 parts and each limma in 4 parts, and obtain a near-isomorphic 53-layout, a few additional higher primes and a few pitches from the subdominant series have been added to complete the scale (69, 7/6, 315, 65/48, 177, 23, 19/12, 5/3, 59, 31, 95/48).",
  "scale": [
    "65/64",
    "33/32",
    "133/128",
    "135/128",
    "17/16",
    "69/64",
    "35/32",
    "143/128",
    "9/8",
    "147/128",
    "7/6",
    "75/64",
    "19/16",
    "77/64",
    "39/32",
    "315/256",
    "5/4",
    "81/64",
    "165/128",
    "21/16",
    "169/128",
    "171/128",
    "65/48",
    "11/8",
    "177/128",
    "45/32",
    "91/64",
    "23/16",
    "189/128",
    "95/64",
    "3/2",
    "49/32",
    "99/64",
    "25/16",
    "19/12",
    "51/32",
    "13/8",
    "105/64",
    "5/3",
    "27/16",
    "55/32",
    "7/4",
    "225/128",
    "57/32",
    "231/128",
    "117/64",
    "59/32",
    "15/8",
    "121/64",
    "31/16",
    "63/32",
    "95/48",
    "2/1"
  ],
  "key_colors_mode": "manual",
  "short_description": "53-OddPart-iso",
  "built_in_group": "Odd Partial Pitch Class Sets",
  "key_labels": "note_names",
  "note_names": [
    "1",
    "65",
    "33",
    "133",
    "135",
    "17",
    "69",
    "35",
    "143",
    "9",
    "147",
    "7/6",
    "75",
    "19",
    "77",
    "39",
    "315",
    "5",
    "81",
    "165",
    "21",
    "169",
    "171",
    "65/48",
    "11",
    "177",
    "45",
    "91",
    "23",
    "189",
    "95",
    "3",
    "49",
    "99",
    "25",
    "19/12",
    "51",
    "13",
    "105",
    "5/3",
    "27",
    "55",
    "7",
    "225",
    "57",
    "231",
    "117",
    "59",
    "15",
    "121",
    "31",
    "63",
    "95/48"
  ],
  "note_colors": [
    "#ff8e8e",
    "#e9d7d3",
    "#dfffd6",
    "#f4e6f2",
    "#fffae5",
    "#cfcfcf",
    "#95c69b",
    "#ffcba8",
    "#90f9cd",
    "#ffffff",
    "#f8c9c9",
    "#ffe5e5",
    "#fef5be",
    "#d6f7ff",
    "#e9ecc1",
    "#e6d7fe",
    "#ffe8e5",
    "#fffae5",
    "#ffffff",
    "#ddfe95",
    "#ffe5e5",
    "#dbb3ff",
    "#d6f7ff",
    "#e9d7d3",
    "#dfffd6",
    "#d2eee9",
    "#fffae5",
    "#ebd0e0",
    "#95c69b",
    "#ffe5e5",
    "#e5fff9",
    "#ffffff",
    "#f8c9c9",
    "#dfffd6",
    "#fef5be",
    "#d6f7ff",
    "#cfcfcf",
    "#e6d7fe",
    "#ffcba8",
    "#fffae5",
    "#ffffff",
    "#ddfe95",
    "#ffe5e5",
    "#fef5be",
    "#d6f7ff",
    "#e9ecc1",
    "#e6d7fe",
    "#d2eee9",
    "#fffae5",
    "#c3ffad",
    "#68f3ec",
    "#ffe5e5",
    "#e5fff9"
  ],
  "equivSteps": 53,
  "fundamental": 440,
  "reference_degree": 40,
  "center_degree": 0,
  "rSteps": 9,
  "drSteps": 4,
  "hexSize": 42,
  "rotation": -16.102113751
}
